import Alpine from 'alpinejs';
import ajax from '@imacrayon/alpine-ajax';
import htmx from 'htmx.org';

// Register Alpine AJAX plugin
Alpine.plugin(ajax);

window.Alpine = Alpine;
window.htmx = htmx;

// Configure Alpine AJAX with WordPress nonce
document.addEventListener('alpine:init', () => {
    const wpNonce = window.wpApiSettings?.nonce || window.nonce;

    if (wpNonce) {
        // Configure Alpine AJAX headers
        Alpine.store('ajax', {
            headers: {
                'X-WP-Nonce': wpNonce,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
    }

    // Popup lightbox store
    Alpine.store('popups', {
        active: null,
        open(slug) {
            this.active = slug;
            document.body.classList.add('overflow-hidden');
        },
        close() {
            this.active = null;
            document.body.classList.remove('overflow-hidden');
        }
    });
});

// Configure HTMX if nonce is available
const wpNonce = window.wpApiSettings?.nonce || window.nonce;
if(wpNonce) {
    document.addEventListener('htmx:configRequest', function(event) {
        event.detail.headers['X-WP-Nonce'] = wpNonce;
    });
}

document.addEventListener('DOMContentLoaded', function() {
    Alpine.start();

    // Intercept clicks on popup trigger links (href="#popup-{slug}")
    document.addEventListener('click', (e) => {
        const link = e.target.closest('a[href^="#popup-"]');
        if (!link) return;
        e.preventDefault();
        const slug = link.getAttribute('href').replace('#popup-', '');
        Alpine.store('popups').open(slug);
    });
});

// Alpine.magic('blockData', (el, { Alpine }) => {
//     // el.parentElement.id is the key of the blockData object
//     let blockData = Alpine.store('blockData')[el.parentElement.id];
//     return blockData;
// });